export enum PayloadType {
  RichText = 'RichText',
  E2ee = 'E2ee',
  File = 'File',
  AudioMessage = 'AudioMessage',
  Image = 'Image',
  LoadImageByLink = 'LoadImageByLink', // only client payload for copy paste image to article from google doc
  Album = 'Album',
  Video = 'Video',
  CircleVideo = 'CircleVideo',
  Sticker = 'Sticker',
  Location = 'Location',
  VoiceMessage = 'VoiceMessage',
  Contact = 'Contact',
  Call = 'Call',
  Article = 'Article',
  Advertisement = 'Advertisement',

  ContainerOrdered = 'container.ordered',

  // deleted by me
  MessageWasDeletedByMe = 'message.was.deleted.by.me',

  // bots
  Buttons = 'Buttons',
  ButtonsSelected = 'buttons.selected',

  Unsupported = 'unsupported',

  // system messages
  SystemStream = 'system.stream',
  SystemCall = 'system.call',
  SystemCallStarted = 'system.call.started',
  SystemCallFinished = 'system.call.finished',
  SystemChatNewlyCreatedWelcome = 'system.chat.newly.created.welcome',
  SystemThreadNewlyCreatedWelcome = 'system.thread.newly.created.welcome',
  SystemChatNewlyCreatedPhoneBookUserJoined = 'system.chat.newly.created.phonebook_user_joined_gem4me',
  SystemChatJoined = 'system.chat.joined',
  SystemChatAdded = 'system.chat.added',
  SystemChatAvatarChanged = 'system.chat.avatar.changed',
  SystemChatMessagePinned = 'system.chat.message.pinned',
  SystemChatMessageUnPinned = 'system.chat.message.unpinned',
  SystemChatOwnerChanged = 'system.chat.owner.changed',
  SystemChatAdminsAdded = 'system.chat.admins.added',
  SystemChatAdminsRemoved = 'system.chat.admins.removed',
  SystemChatDescriptionChanged = 'system.chat.description.changed',
  SystemChatRenamed = 'system.chat.renamed',
  SystemChatUsersRemoved = 'system.chat.users.removed',
  SystemChatUsersBanned = 'system.chat.users.banned',
  SystemChatLeft = 'system.chat.left',
  SystemChatTypeChanged = 'system.chat.type.changed',
  SystemChatCategoryChanged = 'system.chat.category.changed',
  SystemChatMessagesSettingsChanged = 'system.chat.messages.settings.changed',
  SystemChatAddedToSpace = 'system.chat.added.to.space',
  SystemChatRemovedFromSpace = 'system.chat.removed.from.space',
  SystemChatTtlChanged = 'system.chat.ttl.changed',
}
